import { useMutation } from "@tanstack/react-query";

import * as authApi from "../api";
import { useUserActions } from "../store";
import type { SignupData } from "../types";

export function useSignupMutation() {
  const { setToken } = useUserActions();

  return useMutation({
    mutationFn: (payload: SignupData) => authApi.signup(payload),
    onSuccess: (response) => {
      setToken(response.token);
    },
  });
}
